// extracted by mini-css-extract-plugin
export default {"home":"MainPage_home__e3Hum","container":"MainPage_container__CXQzd","home__topimg":"MainPage_home__topimg__zoUGs"};